var D = /* @__PURE__ */ ((E) => (E[E.DISABLED = 1] = "DISABLED", E[E.ACTIVE = 2] = "ACTIVE", E[E.EXPIRED = 3] = "EXPIRED", E[E.REMOVED = 4] = "REMOVED", E))(D || {});
export {
  D as LoyaltyAccountStatus
};
//# sourceMappingURL=loyaltyAccountEnums.js.map
